/** The nearest ancestor that actually scrolls vertically, else the document scroller. */
export function scrollContainerOf(element: HTMLElement | null): HTMLElement | null {
  let current = element?.parentElement ?? null;
  while (current !== null) {
    const { overflowY } = window.getComputedStyle(current);
    if ((overflowY === 'auto' || overflowY === 'scroll') && current.scrollHeight > current.clientHeight) {
      return current;
    }
    current = current.parentElement;
  }
  const doc = document.scrollingElement;
  return doc instanceof HTMLElement && doc.scrollHeight > doc.clientHeight ? doc : null;
}

/** The nearest ancestor that actually scrolls horizontally (the week view's narrow scroller). */
export function horizontalScrollContainerOf(element: HTMLElement | null): HTMLElement | null {
  let current = element?.parentElement ?? null;
  while (current !== null) {
    const { overflowX } = window.getComputedStyle(current);
    if ((overflowX === 'auto' || overflowX === 'scroll') && current.scrollWidth > current.clientWidth) {
      return current;
    }
    current = current.parentElement;
  }
  const doc = document.scrollingElement;
  return doc instanceof HTMLElement && doc.scrollWidth > doc.clientWidth ? doc : null;
}
